'use es6';

import { LISTING_TYPE_ID } from '../../../data/objectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const Listing = ObjectDefinitionRecord({
  enableAsAssociatedType: true,
  hasAccess: (_isUngated, hasScope) => hasScope('listings-access'),
  objectTypeId: LISTING_TYPE_ID,
  referenceObjectType: 'LISTING_PROPERTIES'
});
export default Listing;